import { useMutation } from 'react-query';
import { DocumentLinkSettingDto } from '../../../../../../codegen/SwaggerProduct';

import { getProductReservationApi } from '../../../../../../config/SwaggerProductReservationApi';

const createDocumentLinkManagement = (documentLink: DocumentLinkSettingDto) =>
    getProductReservationApi().documentLinkSetting.createCreate(documentLink)
        .then((response) => response.data);

const useCreateDocumentLinkManagement = () => {
    const useCreateDocumentLinkManagementMutation = useMutation(createDocumentLinkManagement);

    return useCreateDocumentLinkManagementMutation;
};

export default useCreateDocumentLinkManagement;
